"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var http_1 = require("./http");

var uri = '/v4/data/graph/';

function default_1(uuid, time, fields, credentials) {
  return http_1.authorizedHTTP(credentials).get(uri + uuid.string(), {
    params: {
      time: Math.floor(time.getTime() / 1000),
      fields: fields.join(",")
    },
    headers: {
      'Authorization': 'Bearer ' + credentials.token()
    }
  }).then(function (resp) {
    return resp.data;
  });
}

exports.default = default_1;